import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { insights } from '../data/insights';
import { formatDate } from '../utils/date';
export function Insights() {
  const [featured, ...rest] = insights;
  return <>
      <PageHero breadcrumb="Insights" title="Perspectives on leadership and governance." lead="Practical thinking for boards, chief executives, and senior leaders navigating succession, selection, and change." data-id="element-455" data-mp="2xuuf0tf0fyot" />
      <section className="bg-ivory" data-id="element-456" data-mp="2nxprap5inv5w">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-457" data-mp="2su6l9zzed3qw">
          <Reveal data-id="element-458" data-mp="1cgg5hvyx0r1f">
            <Link to={`/insights/${featured.slug}`} className="group grid gap-8 rounded-lg bg-midnight-900 p-10 text-champagne-50 lg:grid-cols-12 lg:p-14" data-id="element-459" data-mp="1cfwxp82zbj14">
              <div className="lg:col-span-7" data-id="element-460" data-mp="1hdgbk6vrltsj">
                <p className="text-sm text-champagne-300" data-id="element-461" data-mp="s2fwuznqpgnk">
                  {featured.category} · {formatDate(featured.date)} · {featured.readTime}
                </p>
                <h2 className="mt-5 font-serif text-4xl leading-tight transition-colors duration-150 ease-out group-hover:text-champagne-200 md:text-5xl" data-id="element-462" data-mp="121ducs358kip">
                  {featured.title}
                </h2>
              </div>
              <div className="flex flex-col lg:col-span-4 lg:col-start-9" data-id="element-463" data-mp="1b1acsbyxwn5b">
                <p className="text-[16px] leading-relaxed text-champagne-100/70" data-id="element-464" data-mp="170grlqcvtmg4">{featured.excerpt}</p>
                <span className="mt-auto inline-flex items-center gap-2 pt-8 text-sm font-medium text-champagne-200" data-id="element-465" data-mp="1krltkz3q2qtm">
                  Read article <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-466" data-mp="1fttrjc9d5obp" />
                </span>
              </div>
            </Link>
          </Reveal>

          <ul className="mt-16 grid gap-x-10 md:grid-cols-3" data-id="element-467" data-mp="1pst0yx1ydnzr">
            {rest.map((article, i) => <li key={article.slug} className="border-t border-midnight-900/15" data-id="element-468" data-mp="1wvzizkp7a27l" data-mpi={i}>
                <Reveal delay={i * 0.04} className="h-full" data-id="element-469" data-mp="21tsoebiois6t">
                  <Link to={`/insights/${article.slug}`} className="group flex h-full flex-col py-8" data-id="element-470" data-mp="26ru7uxk0otit">
                    <p className="text-sm text-midnight-900/55" data-id="element-471" data-mp="2bjknnj1q49hm">
                      {article.category} · {formatDate(article.date)}
                    </p>
                    <h3 className="mt-3 font-serif text-2xl leading-snug text-midnight-900 transition-colors duration-150 ease-out group-hover:text-midnight-600" data-id="element-472" data-mp="2gk8adsix6461">
                      {article.title}
                    </h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-midnight-900/70" data-id="element-473" data-mp="2uhogt417txxs">{article.excerpt}</p>
                    <span className="mt-auto pt-6 text-sm text-midnight-900/55" data-id="element-474" data-mp="v5c9ocv0r8hl">{article.readTime}</span>
                  </Link>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>
      <CtaBand data-id="element-475" data-mp="sl68ue1pby59" />
    </>;
}